export const setLocalStorage = (key: string, value: any) => {
  try {
      if (typeof value === "string") {
          localStorage.setItem(key, value); // ✅ Directly save string
      } else {
          localStorage.setItem(key, JSON.stringify(value)); // ✅ JSON.stringify() for objects/arrays
      }
  } catch (error) {
      console.error("Error setting localStorage:", error);
  }
};

export const getLocalStorage = (key: string) => {
  try {
      const data = localStorage.getItem(key);
      console.log("datadatadata",data,key)
      if (!data) return null;

      if (data.startsWith("{") || data.startsWith("[")) {
          return JSON.parse(data); // ✅ Parse only JSON values
      }
      
      return data; // ✅ Return as string if it's not JSON
  } catch (error) {
      console.error("Error getting localStorage:", error);
      return null;
  }
};

export const removeLocalStorage = (key: string) => {
  try {
      localStorage.removeItem(key);
  } catch (error) {
      console.error("Error removing localStorage:", error);
  }
};
